module.exports = __webpack_public_path__ + "eca3c0cd7a31949cfd45ec12c4723e30.png";